import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row} from "react-bootstrap";
import Dropdown from "../../../primer/Dropdown";
import {chequeTypes} from "../../../../_helpers/commonFunctions";
import {setNewCheque} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import axios from "axios";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import {setSaveNewCheque} from "../../../../_reducers/activitySlice";
import AccountingBox from "../../../primer/AccountingBox";
import TextArea from "../../../common/TextArea";

const ChequeNew = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const saveNewCheque = useSelector((state) => state.ACTIVITY.saveNewCheque);
    const newCheque = useSelector((state) => state.CASH_DATA.newCheque);
    const [entitiesList, setEntitiesList] = useState([]);

    const entityTypes = [
        {label: "Πελάτης", value: "client"},
        {label: "Προμηθευτής", value: "supplier"},
    ]

    useEffect(() => {
        loadCorrelatedEntitiesList(null, setEntitiesList)
    }, [newCheque.entityType]);

    const loadCorrelatedEntitiesList = (keyword, setData) => {
        let endpoint = "";
        if (newCheque.entityType === "client") endpoint = "/client/list-client";
        if (newCheque.entityType === "supplier") endpoint = "/supplier/list-supplier";

        if (endpoint) {
            const reqData = { company: company.id }
            if (keyword) reqData.name = keyword;

            axios.post(`${process.env.REACT_APP_API_URL2}${endpoint}`, reqData, {
                headers: {"Content-Type": "application/json"}
            }).then((res) => {
                if (res.data && res.data.status === "200") {
                    if (res.data.data) setData(res.data.data);
                    else setData([]);
                } else {
                    setData([]);
                }
            }).catch((e) => {
                console.log(e);
            })
        }
    }

    const handleOnChange = (e, type, name) => {
        if (!saveNewCheque) dispatch(setSaveNewCheque(true));

        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
            if (name === "type") {
                if (e.value === 0 && newCheque.entityType === "supplier" && !newCheque.entityId) prepChange["entityType"] = "client";
                else if (e.value === 1 && newCheque.entityType === "client" && !newCheque.entityId) prepChange["entityType"] = "supplier";
            }
            if (name === "entityType" && e.value !== newCheque.entityType) {
                prepChange["entityId"] = "";
                prepChange["entityName"] = "";
            }
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        } else if (type === "acdd") {
            prepChange["entityId"] = e.row._id;
            prepChange["entityName"] = e.row.name;
        } else if (type === "db") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).toDate();
            } else {
                prepChange[name] = "";
            }
        } else if (type === "ab") {
            let val = e.target.value;
            if (isNaN(+val) || +val <= 0) {
                val = 0;
            } else {
                val = +Number(val).toFixed(2);
            }
            prepChange[name] = val;
        }
        dispatch(setNewCheque({...newCheque, ...prepChange}));
    }

    return (
        <div className={"mb-3"}>
            <Row>
                <Col md={2}>
                    <Dropdown
                        name={"type"}
                        label={"Τύπος Επιταγής"}
                        options={chequeTypes}
                        defaultValue={chequeTypes.find((el) => el.value === newCheque.type)}
                        key={Math.random()}
                        onChange={(e) => handleOnChange(e, "dd", "type")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"issueDate"}
                        label={"Ημερομηνία Έκδοσης"}
                        required={true}
                        selected={moment(newCheque.issueDate).isValid() ? moment(newCheque.issueDate).toDate() : null}
                        allowOtherYears={true}
                        onChange={(e) => handleOnChange(e, "db", "issueDate")}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"expiryDate"}
                        label={"Ημερομηνία Λήξης"}
                        selected={moment(newCheque.expiryDate).isValid() ? moment(newCheque.expiryDate).toDate() : null}
                        allowOtherYears={true}
                        onChange={(e) => handleOnChange(e, "db", "expiryDate")}
                    />
                </Col>
                <Col md={3}>
                    <label>Ποσό (€)</label>
                    <AccountingBox
                        name={"amount"}
                        key={newCheque.amount}
                        defaultValue={newCheque.amount}
                        onBlur={(e) => handleOnChange(e, "ab", "amount")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"numbering"}
                        label={"Αριθμός Επιταγής"}
                        required={true}
                        autoComplete={"off"}
                        value={newCheque.numbering}
                        onChange={(e) => handleOnChange(e, "input", "numbering")}
                    />
                </Col>
            </Row>
            <Row className={"mb-3"}>
                <Col md={3}>
                    <Dropdown
                        name={"entityType"}
                        label={"Τύπος Αντισυμβαλλόμενης Οντότητας"}
                        options={entityTypes}
                        defaultValue={entityTypes.find((el) => el.value === newCheque.entityType)}
                        key={Math.random()}
                        onChange={(e) => handleOnChange(e, "dd", "entityType")}
                    />
                </Col>
                <Col md={6}>
                    <AdvancedCombobox
                        name="entityName"
                        className="w-100 ac-select-dropdown"
                        defaultValue={newCheque.entityName}
                        label={"Συσχετιζόμενη οντότητα"}
                        data={entitiesList}
                        key={newCheque.entityId}
                        onChange={(e) => handleOnChange(e, "acdd", "entityName")}
                        resetFilter={() => dispatch(setNewCheque({...newCheque, entityId: "", entityName: ""}))}
                        onChangeSearch={loadCorrelatedEntitiesList}
                        excludeColumns={[]}
                        columns={[
                            {label: "Όνομα", name: "name"},
                            {label: "ΑΦΜ", name: "vatNumber"},
                            {label: "Τηλέφωνο", name: "phone"},
                        ]}
                        deleteEnable={false}
                        searchTableEnable={false}
                        showTableOptionOnSelect={true}
                        placeholder={"Εισάγετε συσχετιζόμενη οντότητα"}
                        required={true}
                        showInsertAddButton={true}
                        hideSaveButton={true}
                        hideInsertNewRow={true}
                        inputFieldClasses="form-control"
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <TextArea
                        name={"notes"}
                        label={"Σημειώσεις"}
                        rows={4}
                        value={newCheque.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                    />
                </Col>
            </Row>
        </div>
    )
}

export default ChequeNew;
